/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import parse from 'html-react-parser';

const ReadMore = ({ content, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const displayContent = isExpanded ? content : `${content.slice(0, maxLength)}...`;

  return (
    <div>
      <div>{parse(displayContent)}</div>
      <button type="button" onClick={toggleExpanded} className="bg-blue-500 xl:p-6 p-4 md:px-8 px-4 text-white xl:text-lg text-sm text-black font-semibold m-3 hover:bg-blue-700 ">
        {isExpanded ? 'Read Less' : 'Read More'}
      </button>
    </div>
  );
};

export default ReadMore;
